import {Component, Input} from '@angular/core';
import {SwiperOptions} from 'swiper/types';
import {PlaceCheckInApiModel} from '../../../../../api/models/place-check-in.api-model';
import {CurrentUserViewModel} from '../../../../../core/models/current-user.view-model';
import {SocialDataProviderService} from '../../../../timeline/social-grid-list/social-data-provider.service';
import {SocialListItemRenderer} from '../social-list-item-renderer.interface';

@Component({
  selector: 'app-place-check-in-list-item',
  templateUrl: './place-check-in-list-item.component.html',
})
export class PlaceCheckInListItemComponent implements SocialListItemRenderer<PlaceCheckInApiModel> {
  @Input() public item: PlaceCheckInApiModel;
  @Input() public currentUser: CurrentUserViewModel;
  @Input() public socialDPS: SocialDataProviderService;
  @Input() public navigateTo: (item: PlaceCheckInApiModel) => void;
  @Input() public swiperConfig: SwiperOptions;
  @Input() public rendererInputs?: Record<string, unknown>;
}
